import { render, staticRenderFns } from "./equipeDetalhe.vue?vue&type=template&id=856cf172&scoped=true&"
import script from "./equipeDetalhe.vue?vue&type=script&lang=js&"
export * from "./equipeDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./equipeDetalhe.vue?vue&type=style&index=0&id=856cf172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856cf172",
  null
  
)

export default component.exports